export default __webpack_public_path__ + "static/media/downloadAsh.2040fa9a.svg";